import logoCompact from '../../assets/logo/KPC23-Logotype-sans-fond-01-small.webp';
import logoFull from '../../assets/logo/KPC23-Logotype-baseline-sans-fond-01-small.webp';

export const LogoIcon = ({ compact }: { compact?: boolean }) => {
  const logo = compact ? logoCompact : logoFull 
  const height = compact ? 32 : 56 
  return <img src={logo} height={height} alt="KPC" />;
};
